import { render, staticRenderFns } from "./ResourcesMonitoringSingleMore.vue?vue&type=template&id=0b0ff9c0&"
import script from "./ResourcesMonitoringSingleMore.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoringSingleMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports